import { c as _c } from "react/compiler-runtime";
import { Circle } from 'lucide-react';
import { cn } from '@/lib/utils';
type RequestedReviewIconProps = {
  className?: string;
  iconClassName?: string;
  useSlot?: boolean;
};
export function RequestedReviewIcon(t0) {
  const $ = _c(11);
  const {
    className,
    iconClassName,
    useSlot: t1
  } = t0;
  const useSlot = t1 === undefined ? true : t1;
  const t2 = useSlot ? "size-4" : null;
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("inline-flex items-center justify-center", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== iconClassName) {
    t4 = cn("fill-current text-yellow-700", iconClassName);
    $[3] = iconClassName;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: "0.5rem",
      height: "0.5rem"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <Circle className={t4} style={t5} strokeWidth={2.25} />;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = <span className={t3}>{t6}</span>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}